module.exports = __webpack_public_path__ + "static/img/security-list-null.fb368ee1.png";